import axios from 'axios';
import { ApiPathRESE } from "../../../common/api-path/ApiPath";

export const getReseBmsTableData = async (pageNumber, pageSize, sortBy, sortDirection, filterCondition) => {
    const requestConfig = {
        params: {pageNumber, pageSize, sortBy, sortDirection, filterCondition}
    }
    const response = await axios.get(`${ApiPathRESE.baseUrl}/getBms`, requestConfig );
    if(response.status >= 400) {
        throw new Error(response.errors);
    }
    return response.data;
}

export const getReseBmsTableDistinctColumnData = async (columnPayload) => {
    const response = await axios.post(`${ApiPathRESE.baseUrl}/getDistinctColumnValue`, columnPayload);
    if(response.status >= 400) {
        throw new Error(response.errors);
    }
    return response.data;
}

export const getReseBmsVersionAndFirmwareColumnData = async (brandName) => {
    const requestConfig = {
        params: { brandName }
    }
    const response = await axios.get(`${ApiPathRESE.baseUrl}/getBmsFirmwareAndVersionDetailsByBrand`, requestConfig);
    if(response.status >= 400) {
        throw new Error(response.errors);
    }
    return response.data;
}

export const updateReseBmsTableData = async (reseBmsTableData) => {
    const response = await axios.put(`${ApiPathRESE.baseUrl}/updateBms`, reseBmsTableData);
    if (response.status >= 400) {
        throw new Error( response.errors)
    }
    return response.data
}